import type { ThemeConfig } from 'antd';

const theme: ThemeConfig = {
  token: {
    colorPrimary: '#FFDC87',
  },
  components: {
    Message: {
      contentBg: 'rgba(40, 42, 46, 1)',
      borderRadiusLG: 24,
      colorText: 'rgba(255, 255, 255, 0.9)',
      colorInfo: 'rgba(255, 255, 255, 0.9)',
      colorWarning: 'rgba(255, 255, 255, 0.9)',
      colorSuccess: 'rgba(255, 255, 255, 0.9)',
      colorError: 'rgba(255, 255, 255, 0.9)',
    },
    Popover: {
      colorBgElevated: 'rgba(40, 42, 46, 1)',
      borderRadiusLG: 50,
    },
    Button: {
      defaultBg: 'rgba(253, 220, 139, 1)',
      defaultBorderColor: 'rgba(253, 220, 139, 1)',
      defaultColor: '#5E3A20',
      colorPrimary: 'rgba(253, 220, 139, 1)',
      defaultGhostBorderColor: 'rgba(253, 220, 139, 1)',
      defaultGhostColor: 'rgba(253, 220, 139, 1)',
    },
    Modal: {
      contentBg: 'rgba(41, 42, 46, 1)',
      colorIcon: 'rgb(148, 149, 151)',
      borderRadiusLG: 24,
    },
    Spin: {
      colorPrimary: 'rgba(253, 220, 139, 1)',
      colorText: 'rgba(253, 220, 139, 1)',
    },
    Input: {
      activeBg: 'rgba(255, 255, 255, 0.10)',
      hoverBg: 'rgba(255, 255, 255, 0.10)',
      activeBorderColor: 'transparent',
      hoverBorderColor: 'transparent',
    },
    Radio: {
      radioSize: 20,
    },
    Drawer: {
      colorBgElevated: '#1C1D20',
      colorIcon: 'rgb(156, 156, 156)',
      colorIconHover: 'rgba(253, 220, 139, 1)',
    },
    Select: {
      colorBorder: 'rgba(51, 53, 59, 1)',
      selectorBg: 'rgba(51, 53, 59, 1)',
      optionActiveBg: '#FFE3A2',
      optionSelectedBg: '#FFE3A2',
      colorIcon: 'rgba(204, 204, 204, 1)',
    },
    Dropdown: {
      colorText: 'rgba(255, 255, 255, 0.50)',
      colorBgElevated: 'rgba(40, 42, 46, 1)',
      controlItemBgActive: 'rgba(255, 228, 165, 1)',
      controlItemBgActiveHover: 'rgba(255, 228, 165, 1)',
      controlItemBgHover: 'rgba(255, 228, 165, 1)',
    },
    Collapse: {
      contentBg: '#000',
      headerBg: '#000',
      colorBorder: 'rgba(238, 238, 238, 1)',
      colorText: '#fff',
      colorTextHeading: '#fff',
      borderRadiusLG: 0,
    },
  },
};
export default theme;
